import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Jsonsmkyu9xjl7fv as Json } from '../../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/Json.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringDeferringConfigClass;
function StringDeferringConfig() {
  if (StringDeferringConfigClass === VOID) {
    class $ {
      constructor(serializersModule, ignoreUnknownKeys, nullMarker, deferMarker, deferredFormat) {
        ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
        nullMarker = nullMarker === VOID ? 'null' : nullMarker;
        deferMarker = deferMarker === VOID ? '%' : deferMarker;
        var tmp;
        if (deferredFormat === VOID) {
          tmp = Json(VOID, ($this$Json) => {
            $this$Json.d29_1 = serializersModule;
            $this$Json.o28_1 = ignoreUnknownKeys;
            $this$Json.n28_1 = true;
            $this$Json.m28_1 = true;
            $this$Json.p28_1 = true;
            return Unit_instance;
          });
        } else {
          tmp = deferredFormat;
        }
        deferredFormat = tmp;
        this.yer_1 = serializersModule;
        this.zer_1 = ignoreUnknownKeys;
        this.aes_1 = nullMarker;
        this.bes_1 = deferMarker;
        this.ces_1 = deferredFormat;
      }
    }
    initMetadataForClass($, 'StringDeferringConfig');
    StringDeferringConfigClass = $;
  }
  return StringDeferringConfigClass;
}
//region block: exports
export {
  StringDeferringConfig as StringDeferringConfig2dp4ygunddfnv,
};
//endregion

//# sourceMappingURL=StringDeferringConfig.mjs.map
